import type { AuthenticatedUser } from '@emazy/shared-types';

import { mapCognitoGroups } from './cognitoRoleMapper';
import type { CognitoSessionLike, CognitoUserLike } from './types';

const stringClaim = (value: unknown) => (typeof value === 'string' ? value : '');
const booleanClaim = (value: unknown) => value === true || value === 'true';

export function mapCognitoUser(
  user: CognitoUserLike,
  session: CognitoSessionLike,
): AuthenticatedUser {
  const identity = session.tokens?.idToken?.payload ?? {};
  const access = session.tokens?.accessToken.payload ?? {};
  const email = stringClaim(identity.email) || user.signInDetails?.loginId || user.username;
  const firstName = stringClaim(identity.given_name);
  const lastName = stringClaim(identity.family_name);
  const displayName = [firstName, lastName].filter(Boolean).join(' ') || email || 'Emazy customer';
  return {
    id: stringClaim(identity.sub) || user.userId,
    email,
    emailVerified: booleanClaim(identity.email_verified),
    firstName,
    lastName,
    displayName,
    roles: mapCognitoGroups(access['cognito:groups'] ?? identity['cognito:groups']),
  };
}
